import React, { useState } from "react";
import "./HomePage.css";

const HomePage = () => {
  const logo = `${process.env.PUBLIC_URL}/images/portify trading logo.png`;
  const heroImage = `${process.env.PUBLIC_URL}/images/tradingbg.jpg`;

  // State to control modal visibility
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Function to toggle modal visibility
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div className="landing-page">
      {/* Navigation Bar */}
      <nav className="navbar">
        <img src={logo} alt="Portify Logo" className="navbar-logo" />
        <ul className="navbar-menu">
          <li>Home</li>
          <li>About</li>

          <li>Contact</li>
        </ul>
        <button className="navbar-signup" onClick={toggleModal}>
          Sign Up
        </button>
      </nav>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-text">
          <h1>
            Welcome to <span className="highlight">Portify Trading </span>
          </h1>
          <h2>We are launching soon...</h2>
          <button className="btn-register" onClick={toggleModal}>
            Register Now
          </button>
        </div>
        <div className="hero-image">
          <img src={heroImage} alt="Trading Illustration" />
        </div>
      </section>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={toggleModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>Launching Soon!</h3>
            <p>Stay tuned for updates on our official launch.</p>
            <button className="close-modal" onClick={toggleModal}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePage;
